import { Box, styled } from '@mui/material';

export const TableRowContainer = styled(Box)(({ theme }) => ({
  height: '90px',
  borderBottom: `2px solid ${theme.palette.primary.dark}`,
  display: 'flex',
  padding: `0 ${theme.spacing(2)}`,
}));
